@if (activities.length > 0) {
  <div class="tool-pills" [class.tool-pills--steps]="layout === 'steps'"
    role="status" aria-label="Agent tool activity">
    @for (tool of displayed; track $index) {
      <span class="tool-pill"
        [class.tool-pill--running]="tool.status === 'running'"
        [class.tool-pill--done]="tool.status === 'done'"
        [class.tool-pill--error]="tool.status === 'error'"
        [class.tool-pill--faded]="isTruncated && !expanded && $index === displayed.length - 1">

        <i class="pi"
          [class.pi-spin]="tool.status === 'running'"
          [class.pi-cog]="tool.status === 'running'"
          [class.pi-check]="tool.status === 'done'"
          [class.pi-times]="tool.status === 'error'"
          aria-hidden="true">
        </i>

        <span class="tool-pill__name">{{ getLabel(tool.name, tool.status) }}</span>

        @if (tool.status === 'done' && tool.count !== undefined) {
          <span class="tool-pill__badge">{{ tool.count }}</span>
        }

        @if (tool.status === 'error' && tool.error) {
          <span class="tool-pill__error">{{ tool.error }}</span>
        }

      </span>
    }

    @if (isTruncated) {
      <button type="button" class="tool-pills__toggle" (click)="toggle()" [attr.aria-expanded]="expanded">
        {{ expanded ? 'Show fewer' : hiddenCount + ' more tool calls' }}
      </button>
    }
  </div>
}
